import React, { useRef } from 'react';

import cx from 'classnames';
import { prop } from 'ramda';

import InputError from 'components/shared/FormAdapters/FormDefault/FormGroup/Error';
import Label from 'components/shared/FormAdapters/FormDefault/Label';
import Text from 'components/shared/Typography/Text';
import useFormGroupAdapter from 'hooks/useFormGroupAdapter';

import FormInput from '../FormInput';
import styles from './index.module.css';

const FormGroup = (props) => {
  const { children, withChildren } = props;

  const [groupProps, inputProps] = useFormGroupAdapter(props);
  const { className, error, help, label, name, invalid, customComponent } = groupProps;
  const { labelDescription, noTransform, noMargin, inline, isLabelInside, value, ...restInputProps } = inputProps;
  const Component = customComponent ?? FormInput;
  const formGroupClasses = cx(
    className,
    styles.formGroup,
    prop(`formGroup-${inputProps.type}`, styles),
    noMargin && prop('formGroup-noMargin', styles),
    inline && prop('formGroup-inline', styles),
    'custom-form-group',
  );
  const fieldTipsRef = useRef(null);

  return (
    <div className={formGroupClasses}>
      {label && !isLabelInside && (
        <Label
          className={cx(styles.formLabel, labelDescription && styles.zeroPadding)}
          isError={invalid}
          htmlFor={name}
          noTransform={noTransform}
        >
          {label}
        </Label>
      )}
      {labelDescription && (
        <Label className={styles.formLabelDescription} isError={invalid} htmlFor={name} noTransform={noTransform}>
          <span style={{ fontSize: 'var(--font_size-base)' }}>{labelDescription}</span>
        </Label>
      )}

      {withChildren ? (
        children
      ) : (
        <Component value={value} isError={invalid} fieldTipsRef={fieldTipsRef} {...restInputProps} />
      )}

      {invalid && error && <InputError error={error} className={cx(styles.inputError, 'custom-input-error')} />}

      {/*useful for showing tips for fields, i.e. Password requirements*/}
      <div className={styles.popup} ref={fieldTipsRef} />

      {!invalid && help && (
        <div className={cx(styles.formHelp, 'custom-form-help')}>
          <Text size="small" accent>
            {help}
          </Text>
        </div>
      )}
    </div>
  );
};

export default FormGroup;
